module.exports = __webpack_public_path__ + "static/noise-0c718a75edce73edfdafa2faeccf6c3c.png";